import { render, staticRenderFns } from "./pip-instructions.vue?vue&type=template&id=52c187b0&"
import script from "./pip-instructions.vue?vue&type=script&lang=js&"
export * from "./pip-instructions.vue?vue&type=script&lang=js&"
import style0 from "./pip-instructions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pip-instructions.vue"
export default component.exports